<template>
  <b-row :class="rowBorderClass">
    <b-col cols="auto">
      <p :class="`text-primary mb-0 ${freelancerLabelClass}`">{{label}}</p>
      <p :class="`text-secondary mb-0 ${freelancerLabelClass}`">{{content}}</p>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: "timesheetRow",
    props: {
      label: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      }
    },
    computed: {
      rowBorderClass() {
        return this.isFreelancer() ? 'border-bottom-2' : 'border-bottom';
      },
      freelancerLabelClass() {
        return this.isFreelancer() ? 'font-weight-500' : '';
      }
    }
  }
</script>

<style scoped>
  .border-bottom-2 {
    border-bottom: 2px solid #898b92 !important;
    width: 75%;
  }
</style>
